export default __webpack_public_path__ + "static/media/linked-in.26bdf871.svg";